import { render, staticRenderFns } from "./cohort-list.vue?vue&type=template&id=4dc83412&scoped=true&"
import script from "./cohort-list.ts?vue&type=script&lang=ts&"
export * from "./cohort-list.ts?vue&type=script&lang=ts&"
import style0 from "./cohort-list.scss?vue&type=style&index=0&id=4dc83412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc83412",
  null
  
)

export default component.exports